export default __webpack_public_path__ + "static/logo_haier_search-fc861c82d209c2c7951508e177d44605.jpg";